'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VueLoader = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vue2Filters = require('vue2-filters');

var _vue2Filters2 = _interopRequireDefault(_vue2Filters);

var _vueOutsideEvents = require('vue-outside-events');

var _vueOutsideEvents2 = _interopRequireDefault(_vueOutsideEvents);

var _vueObserveVisibility = require('vue-observe-visibility');

var _vueObserveVisibility2 = _interopRequireDefault(_vueObserveVisibility);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// todo - remove when we convert all js to vue components
// This is used to access Vuex from outside Vue
window.theme.vuex = _store2.default;

// ignore custom html elements inside Vue
/* eslint-env browser */

_vue2.default.config.ignoredElements = ['klarna-placement'];

_vue2.default.use(_vue2Filters2.default);
_vue2.default.use(_vueOutsideEvents2.default);
_vue2.default.use(_vueObserveVisibility2.default);

var VueLoader = exports.VueLoader = function () {
  function VueLoader(id, data, type, path) {
    (0, _classCallCheck3.default)(this, VueLoader);

    this._sectionId = id;
    this._appType = type;
    this._appPath = path;
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }

  (0, _createClass3.default)(VueLoader, [{
    key: 'getSectionId',
    value: function getSectionId() {
      return this._sectionId;
    }
  }, {
    key: 'setMountingNode',
    value: function setMountingNode() {
      var parent = document.querySelector('div[data-app-id="' + this._sectionId + '"][data-app-type="' + this._appType + '"]');
      this._appData.liquidContent = parent.innerHTML;

      this._mountingNode = parent;
    }
    // required

  }, {
    key: 'kill',
    value: function kill() {
      this._appInstance.kill();
    }
    // required

  }, {
    key: 'init',
    value: function init() {
      var _this = this;

      this.setMountingNode();

      var component = function component() {
        return import( /* webpackChunkName: "[request]" */'' + _this._appPath);
      };

      if (component) {
        this._appInstance = new _vue2.default({
          el: this._mountingNode,
          store: _store2.default,
          render: function render(instance) {
            return instance(component, {
              props: Object.assign({}, _this._appData)
            });
          },
          methods: {
            kill: function kill() {
              this.$destroy();
            }
          }
        });
      }
    }
  }]);
  return VueLoader;
}();